import {ClientScoutCustomerState} from "../store/client_scout_customer_state";
import {Reducer} from "redux";
import {
    ClientScoutCustomerAction,
    ClientScoutCustomerActionType,
    ICallbackCopyHighlightsAction,
    ICallbackCreateClientBookmarkAction,
    ICallbackCreateScoutCustomerAction,
    ICallbackDeleteClientBookmarkAction,
    ICallbackGetCustomerAction,
} from "../action/client_scout_customer_action";

const initialState: ClientScoutCustomerState = {
    customer: null,
    sameOccupationCustomers: [],
    jobCareersWithSameOccupationCustomerID: [],
    company: null,
    projects: [],
    jobCareers: [],
    pastCaseProjects: [],
    messageRoom: null,
    clientBookmarks: [],
    highlights: [],
    isLoading: false,
};

const clientScoutCustomerReducer: Reducer<ClientScoutCustomerState> = (state = initialState, action: ClientScoutCustomerAction): ClientScoutCustomerState => {
    switch (action.type) {

        case ClientScoutCustomerActionType.REQUEST_GET_CUSTOMER: {
            return Object.assign({}, state, {
                isLoading: true,
            });
        }
        case ClientScoutCustomerActionType.CALLBACK_GET_CUSTOMER: {
            const _action = action as ICallbackGetCustomerAction;
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    customer: _action.item ? _action.item.customer : null,
                    company: _action.item ? _action.item.company : null,
                    jobCareers: _action.item ? _action.item.jobCareers : [],
                    projects: _action.item ? _action.item.projects : [],
                    clientBookmarks: _action.item ? _action.item.clientBookmarks : [],
                    pastCaseProjects: _action.item ? _action.item.pastCaseProjects : [],
                    sameOccupationCustomers: _action.item ? _action.item.sameOccupationCustomers : [],
                    jobCareersWithSameOccupationCustomerID: _action.item ? _action.item.jobCareersWithSameOccupationCustomerID : [],
                    isLoading: false,
                });
            } else {
                return Object.assign({}, state, {
                    isLoading: false,
                });
            }
        }

        case ClientScoutCustomerActionType.REQUEST_CREATE_SCOUT_CUSTOMER: {
            return Object.assign({}, state, {
                isLoading: true,
            });
        }
        case ClientScoutCustomerActionType.CALLBACK_CREATE_SCOUT_CUSTOMER: {
            const _action = action as ICallbackCreateScoutCustomerAction;
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    messageRoom: _action.item ? _action.item.messageRoom : null,
                    isLoading: false,
                });
            } else {
                return Object.assign({}, state, {
                    isLoading: false,
                });
            }
        }

        case ClientScoutCustomerActionType.REQUEST_CREATE_CLIENT_BOOKMARK: {
            return Object.assign({}, state, {
                isLoading: true,
            });
        }
        case ClientScoutCustomerActionType.CALLBACK_CREATE_CLIENT_BOOKMARK: {
            const _action = action as ICallbackCreateClientBookmarkAction;
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    clientBookmarks: _action.item ? _action.item.clientBookmarks : [],
                    isLoading: false,
                });
            } else {
                return Object.assign({}, state, {
                    isLoading: false,
                });
            }
        }

        case ClientScoutCustomerActionType.REQUEST_DELETE_CLIENT_BOOKMARK: {
            return Object.assign({}, state, {
                isLoading: true,
            });
        }
        case ClientScoutCustomerActionType.CALLBACK_DELETE_CLIENT_BOOKMARK: {
            const _action = action as ICallbackDeleteClientBookmarkAction;
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    clientBookmarks: _action.item ? _action.item.clientBookmarks : [],
                    isLoading: false,
                });
            } else {
                return Object.assign({}, state, {
                    isLoading: false,
                });
            }
        }

        case ClientScoutCustomerActionType.REQUEST_COPY_HIGHLIGHTS: {
            return Object.assign({}, state, {});
        }
        case ClientScoutCustomerActionType.CALLBACK_COPY_HIGHLIGHTS: {
            const _action = action as ICallbackCopyHighlightsAction;
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    highlights: _action.item ? _action.item.highlights : []
                });
            } else {
                return Object.assign({}, state, {});
            }
        }

        case ClientScoutCustomerActionType.REQUEST_DELETE_HIGHLIGHTS: {
            return Object.assign({}, state, {});
        }
        case ClientScoutCustomerActionType.CALLBACK_DELETE_HIGHLIGHTS: {
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    highlights: []
                });
            } else {
                return Object.assign({}, state, {});
            }
        }


        default:
            return state;
    }
};

export default clientScoutCustomerReducer;



// WEBPACK FOOTER //
// ./src/presentation/reducer/client_scout_customer_reducer.ts